import { ApiService, WinForm } from "./libs";
import { DataService } from "./service";

/**
 * 版本号比较
 * @param v1
 * @param v2
 * @returns {number}
 * compareVersion('7.0.5', '6.0.6') // => 1 // 1表示 1比2要新
 * compareVersion('7.0.5', '1.11.0') // => 0 // 0表示1和2是同一个版本
 * compareVersion('6.0.5', '6.0.6') // => -1 // -1表示1比 2要老
 */
function compareVersion(v1, v2) {
	v1 = v1.split(".");
	v2 = v2.split(".");
	const len = Math.max(v1.length, v2.length);
	while (v1.length < len) {
		v1.push("0");
	}
	while (v2.length < len) {
		v2.push("0");
	}
	for (let i = 0; i < len; i++) {
		const num1 = parseInt(v1[i]);
		const num2 = parseInt(v2[i]);

		if (num1 > num2) {
			return 1;
		} else if (num1 < num2) {
			return -1;
		}
	}
	return 0;
}

function getAppName() {
	// 新版本客户端增加了getAppName方法
	let clientAppName = '';
	try {
		clientAppName = window.md.getAppName();
	} catch (error) {}
	// 软件的安装目录
	let path = window.md.getAppPath();
	const appConfig = {
		dggj: { appName: '大国工匠PC', appKey: 'dggj' },
		dggjEnt: { appName: '大国工匠企业版PC', appKey: 'dggjEnt' },

		GreatCraftsman: { appName: '大国工匠PC', appKey: 'GreatCraftsman' },
		GreatCraftsmanEnt: { appName: '大国工匠企业版PC', appKey: 'GreatCraftsmanEnt' },
		GreatCraftsmanInEnt: {appName: '大国工匠PC-行业版PC', appKey: 'GreatCraftsmanInEnt' },
		GreatCraftsmanInJgEnt: {appName: '大国工匠PC-激光行业版PC', appKey: 'GreatCraftsmanInJgEnt' },

		BigEngineer: { appName: '大工程师PC', appKey: 'BigEngineer' },
		KYBao: { appName: '主配链PC', appKey: 'KYBao' },
		BigEngineerEnterprise: { appName: '大工程师-企业版PC', appKey: 'BigEngineerEnterprise' },
	};
	const {appName,appKey} = appConfig[clientAppName] || {};
	return { appName, appKey, appPath: path };
}

const clientUpdate = async () => {
	// 当前APP版本号
	const nowVersion = window.md.getAppVersion();

	let { appName, appKey, appPath } = getAppName();
	console.log(`当前${appName}（${appKey}）版本号:${nowVersion}`);

	// 获取新的版本号
	const res = await DataService.get(`${ApiService.ZPChainApi}/madeToday/getVersion?appName=` + appName);
	if (res.code !== 0) {
		return false;
	}
	const versionObj = res.data;
	const newVersion = (versionObj && versionObj.versionNum) || "";
	if (!newVersion) {
		return false;
	}
	// 新老版本号检测
	const check = compareVersion(nowVersion, newVersion);
	if (check === 1 || check === 0) {
		return false;
	}
	if (!appPath) return;
	appPath = `${appPath}\\upgrade\\${appKey}.zip`;
	// 新版本压缩包地址
	const url = versionObj.url;
	if (!url) {
		return false;
	}
	// 检查安装包是否已经在下载中
	// const downStatus = WinForm.storge.get('update_download_status') || {};
	// if (downStatus.status === "MD_DOWNLOAD") {
	// 	console.log(`新版本已经在下载中了`);
	// 	return false;
	// }
	// 开始压缩包下载
	console.log(`开始新版本的后台静默下载`);
	window.md.download2(url, appPath, 'update_download');
};

export function setClientUpdate() {
	if (!window.md) {
		return false;
	}
	window['update_download'] = function (key, progress, speed, status, statusDesc, totalSize) {
		console.log(key, progress, speed, status, statusDesc, totalSize);
		WinForm.storge.set('update_download_status', { status });
		if (status === "MD_COMPLETE") {
			// setTimeout(() => {
			// 	window.md.restart();
			// }, 3000)
			WinForm.md.$emit('engineer_client_download_ok');
		}
	};
	clientUpdate();
}
